module.exports = __webpack_public_path__ + "static/media/generate-reportV2.3839b945.svg";